import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ENDPOINTS } from '../@config/endpoints';
import { QuotationsResult, QuoteEntry } from '../@models';
import { Pagination } from '../@config';
import { QuoteDto } from '../@models/quote-dto.model';

@Injectable({
  providedIn: 'root'
})
export class QuotationsService {

  constructor(private http: HttpClient) { }

  getQuotations(skipCount: number, searchFilter:any): Observable<QuotationsResult> {
    return this.http.get<QuotationsResult>(ENDPOINTS.getQuotations(searchFilter.payload.statusId, searchFilter.payload.productFamilyId, searchFilter.payload.phaseId, searchFilter.payload.isAll, Pagination.maxResultCount, skipCount,  searchFilter.payload.filterString || '')).pipe(
      map((respone: any) => respone?.result || []));
  }

  getAll(skipCount: number, searchFilter:any): Observable<QuoteEntry[]> {
    return this.http.get<QuoteEntry[]>(ENDPOINTS.getQuotations(searchFilter.payload.statusId, searchFilter.payload.productFamilyId, searchFilter.payload.phaseId, searchFilter.payload.isAll, Pagination.maxResultCount, skipCount,  searchFilter.payload.filterString || '')).pipe(
      map((respone: any) => respone?.result?.items || []));
  }

  createOrUpdateQuote(quote: QuoteEntry): Observable<QuotationsResult> {
    console.debug('🔥 new quote payload', quote);
    return this.http.post<QuotationsResult>(ENDPOINTS.createQuote(), quote).pipe(
      map((respone: any) => respone?.result || []));
  }

  getQuoteHTMLCode(quoteId: number): Observable<any> {
    return this.http.get<string>(ENDPOINTS.getQuoteHTMLCode(quoteId));
  }

  getBoldReportQuotePDF(quoteId: number): Observable<any> {
    return this.http.get<string>(ENDPOINTS.getBoldReportQuotePDF(quoteId));
  }

  getQuotationById(quoteId: number): Observable<QuoteDto> {
    return this.http.get<QuoteDto>(ENDPOINTS.getQuotationById(quoteId)).pipe(
      map((respone: any) => respone?.result || []));
  }

}
